// Shared clinic + brand constants for Clenchless.
// Sub-brand of restore.dental — same clinic, same dentist, focused on bruxism.

// 📌 Google Calendar booking is currently PARKED — all CTAs go to WhatsApp.
//    To re-enable: set this URL and switch CTAs back in Header/Hero/Pricing/AIQuiz/Contact/Footer.
export const BOOKING_URL = "https://calendar.app.google/REPLACE_ME";
export const BOOKING_ENABLED = false;

export const CLINIC = {
  brandName: "Clenchless",
  brandTagline: "The bruxism clinic",
  parentBrand: "restore.dental",
  parentUrl: "https://restore.dental",
  domain: "clenchless.clinic",
  doctor: {
    name: "Dr. Kartik Patel",
    credentials: "Founder & Principal Dentist",
    bio: "Dr. Kartik Patel is the founder of restore.dental, with 15+ years of clinical experience and 500+ Invisalign cases. The same patient-first philosophy — natural results, built to last — guides every bruxism plan at Clenchless.",
    yearsExperience: "15+",
    rating: "5.0",
  },
  address: {
    line1: "Clenchless @ Perfect Smile Acton",
    line2: "64a Horn Lane",
    postcode: "W3 6NP",
    city: "Acton, West London",
  },
  phoneDisplay: "07877 814 064",
  phoneRaw: "tel:07877814064",
  whatsappNumber: "447877814064",
  whatsappMessage:
    "Hi! I'd like to book a free discovery call about teeth grinding / jaw clenching at Clenchless.",
  email: "hello@clenchless.clinic",
  what3words: "fade.kick.fortunate",
  what3wordsUrl: "https://what3words.com/fade.kick.fortunate",
  mapDirectionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=51.51103445602675,-0.27099170810255924",
  hours: [
    { day: "Mon – Fri", time: "9:00 — 18:00" },
    { day: "Saturday", time: "By appointment" },
    { day: "Sunday", time: "Closed" },
  ],
  pricing: {
    consultation: "Free",
    treatment: "From £350",
    duration: "Short appointment",
    lasts: "Several months",
  },
};

export const whatsappLink = (msg) =>
  `https://wa.me/${CLINIC.whatsappNumber}?text=${encodeURIComponent(
    msg || CLINIC.whatsappMessage,
  )}`;

export const bookingLink = () => BOOKING_URL;
